import { TYPE_FILTER_INVOICE_ERROR } from "constants/DashboardContanst";
import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_AR,
  AUTH_STATUS_CANCEL,
  AUTH_STATUS_CANCEL_WAITING,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
  AUTH_STATUS_REJECT_CANCEL,
  AUTH_STATUS_RR,
} from "constants/FormatDataContanst";
import React, { useEffect, useState } from "react";
import { MetaTags } from "react-meta-tags";
import { useSelector } from "react-redux";
import { issueInvoicePageViewList } from "../utils";
import ListAgentError from "./ListAgentError";
import ListBillError from "./ListBillError";
import ListInvoiceError from "./ListInvoiceError";

const ListErrorTCT = () => {
  //   const listLinkType = [LINK_TYPE.PARENT_ADJUST, LINK_TYPE.CHILD_ADJUST];
  const [filterList, setFilterList] = useState({
    // "filter[is_problem]": 1,
  });
  const [pageView, setPageView] = useState(null);

  const Dashboard = useSelector(state => state.Dashboard);
  const { finalBuInfo } = Dashboard;

  // Action list chang tenantCode
  useEffect(() => {
    if (finalBuInfo) {
      setFilterList({
        ...filterList,
        // "filter[invoice_type]": finalBuInfo?.invoice_type,
      });
      switch (finalBuInfo?.invoice_type) {
        case 1:
          setPageView(issueInvoicePageViewList.PAGE_DELIVERY_BILL_HAVE_CODE);
          break;
        case 0:
          setPageView(issueInvoicePageViewList.PAGE_DELIVERY_BILL_NONE_CODE);
          break;
        default:
          break;
      }
    }
  }, [finalBuInfo]);

  const [typeFilterError, setTypeFilterErrorHandle] = useState(
    TYPE_FILTER_INVOICE_ERROR.INVOICE
  );

  const [isClickSwitch, setIsClickBtn] = useState(false);

  const setTypeFilterError = e => {
    setIsClickBtn(true);
    setTypeFilterErrorHandle(e);
  };

  const switchBtnTypeInvoice = () => {
    return (
      <div className="btn-group " role="group">
        <button
          type="button"
          className={`${
            typeFilterError === TYPE_FILTER_INVOICE_ERROR.INVOICE
              ? "btn-success"
              : "btn-outline-primary"
          } btn w-sm`}
          onClick={() => {
            setTypeFilterError(TYPE_FILTER_INVOICE_ERROR.INVOICE);
          }}
        >
          Hóa đơn
        </button>
        <button
          type="button"
          className={`${
            typeFilterError === TYPE_FILTER_INVOICE_ERROR.INVOICE_WAREHOUSES
              ? "btn-success"
              : "btn-outline-primary"
          } btn w-sm`}
          onClick={() => {
            setTypeFilterError(TYPE_FILTER_INVOICE_ERROR.INVOICE_WAREHOUSES);
          }}
        >
          Phiếu xuất kho vc nội bộ
        </button>
        <button
          type="button"
          className={`${
            typeFilterError === TYPE_FILTER_INVOICE_ERROR.INVOICE_AGENT
              ? "btn-success"
              : "btn-outline-primary"
          } btn w-sm`}
          onClick={() => {
            setTypeFilterError(TYPE_FILTER_INVOICE_ERROR.INVOICE_AGENT);
          }}
        >
          Phiếu xuất kho gửi bán đại lý
        </button>
      </div>
    );
  };

  return (
    <React.Fragment>
      <div className="page-content badge-soft ">
        <MetaTags>
          <title>DANH SÁCH HÓA ĐƠN TREO / LỖI TRUYỀN NHẬN</title>
        </MetaTags>
        {typeFilterError === TYPE_FILTER_INVOICE_ERROR.INVOICE && (
          <ListInvoiceError
            filterList={filterList}
            isClickSwitch={isClickSwitch}
            isErrorTCT={true}
            // listLinkTypeFilter={listLinkType}
            listStatusFilter={[
              AUTH_STATUS_NEW,
              AUTH_STATUS_APPROVE,
              AUTH_STATUS_PROGRESSING,
              AUTH_STATUS_REJECT,
              AUTH_STATUS_CANCEL_WAITING,
              AUTH_STATUS_REJECT_CANCEL,
              AUTH_STATUS_CANCEL,
              AUTH_STATUS_AR,
              AUTH_STATUS_RR,
            ]}
            title={"HÓA ĐƠN TREO / LỖI TRUYỀN NHẬN"}
          >
            {switchBtnTypeInvoice()}
          </ListInvoiceError>
        )}
        {typeFilterError === TYPE_FILTER_INVOICE_ERROR.INVOICE_WAREHOUSES && (
          <ListBillError
            filterList={filterList}
            title={"PHIẾU XUẤT KHO KIÊM VC NỘI BỘ TREO / LỖI TRUYỀN NHẬN"}
            // pageView={pageView}
          >
            {switchBtnTypeInvoice()}
          </ListBillError>
        )}
        {typeFilterError === TYPE_FILTER_INVOICE_ERROR.INVOICE_AGENT && (
          <ListAgentError
            filterList={filterList}
            title={"PHIẾU XUẤT KHO GỬI BÁN ĐẠI LÝ TREO / LỖI TRUYỀN NHẬN"}
            // pageView={pageView}
          >
            {switchBtnTypeInvoice()}
          </ListAgentError>
        )}
      </div>
    </React.Fragment>
  );
};

export default ListErrorTCT;
